import { Card, Group, Text } from '@mantine/core'
import { ReactNode } from 'react'

interface ChartCardProps {
  title: string
  subtitle?: string
  actions?: ReactNode
  children: ReactNode
  height?: number
}

export function ChartCard({ title, subtitle, actions, children, height }: ChartCardProps) {
  return (
    <Card>
      <Group justify="space-between" mb="md" align="flex-start">
        <div>
          <Text fw={600} size="sm">{title}</Text>
          {subtitle && <Text size="xs" c="dimmed">{subtitle}</Text>}
        </div>
        {actions}
      </Group>
      <div style={{ height: height || 'auto' }}>
        {children}
      </div>
    </Card>
  )
}
